export default "__VITE_ASSET__a980ff90__"